import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import amplitude from 'amplitude-js';
import { dismissIncompletePayment } from 'apps/auth/actions/historyAction';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { getHelpMobileIdParams } from 'apps/auth/components/utils/AmplitudeUtils';
import { GET_HELP_CLICKED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { getLangCountryPrefix } from 'apps/auth/helpers/utils';
import { useThemeDetector } from 'apps/auth/hooks/theme';

const IncompletePaymentMorePopup = (props) => {
    const { theme } = useThemeDetector();

    return (
        <>
            <SimplePopup withoutBorder popupRef={props.popupRef}>
                <PopupButton
                    text={props.cancelTransfer}
                    iconName="cross"
                    onClick={(e) => {
                        e.preventDefault();
                        props.popupRef?.current?.close();
                        props.modalRef?.current?.close();
                        props.dismissIncompletePayment();
                    }}
                />
                <PopupButton
                    text={props.morePopupSupportTitle}
                    iconName="lifebuoy"
                    href={`${getLangCountryPrefix(props.lang, props.country)}${props.faqUrl}?mode=${theme}`}
                    onClick={() => {
                        amplitude.getInstance().logEvent(GET_HELP_CLICKED, getHelpMobileIdParams(props.faqUrl));
                        props.popupRef?.current?.close();
                        props.toggleSpinner(true);
                    }}
                />
            </SimplePopup>
        </>
    );
};

IncompletePaymentMorePopup.propTypes = {
    popupRef: PropTypes.shape({ current: PropTypes.object }),
    modalRef: PropTypes.shape({ current: PropTypes.object }),
    cancelTransfer: PropTypes.string,
    morePopupSupportTitle: PropTypes.string,
};

const mapStateToProps = (state) => ({
    morePopupSupportTitle: state.messages.pageMessages.morePopupSupportTitle,
    morePopupFaqTitle: state.messages.pageMessages.morePopupFaqTitle,
    cancelTransfer: state.messages.pageMessages.cancelTransfer,
    lang: state.language.lang,
    userCountry: state.extra?.userCountry,
    country: state.app.country,
});
export default connect(mapStateToProps, { dismissIncompletePayment })(IncompletePaymentMorePopup);
